import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useCallback } from 'react';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkSetActivePanel } from '../../redux/actions/panelsActions';
import { useAppDispatch } from '../../redux/store';
import { PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, SIDE_BETS_PANEL_BORDER_COLOR } from '../../styles/colors';
import { PanelItem } from '../panelItem';
export const PlayerInfoPlacedSideBetPanelItem = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickMyPlacedSideBet = useCallback(() => {
        dispatch(thunkSetActivePanel('sideBets', socketSend));
    }, [dispatch, socketSend]);
    return (_jsx(PanelItem, { onClick: onClickMyPlacedSideBet, color: SIDE_BETS_PANEL_BORDER_COLOR, hoverColor: PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, children: _jsx(IconWithLabelDisplay, { icon: _jsx(CheckCircleRoundedIcon, {}), label: 'Side Bet Placed' }) }));
};
